/**
 * @fileoverview Agent definition for story-weaknesses-v1.
 *
 * Diagnostic pass over the full manuscript that returns a ranked, actionable
 * list of weaknesses ("choke points") tied to specific chapter ranges.
 *
 * Takes only the concatenated written story as input — no plan or snapshot
 * data — and reacts to the manuscript as a developmental editor would.
 *
 * Powers the Weaknesses card on the Story Review page.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'story-weaknesses-v1',
  kind: 'primitive',
  name: 'Story Weaknesses',
  description: 'Reads the full written story and returns a ranked, actionable list of weaknesses ("choke points"), each scoped to a chapter range and tagged by the kind of fix it implies.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-story-weaknesses-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'story-feedback-v1',
      'divergence-report-v2',
    ],
  },
};
